module.exports = __webpack_public_path__ + "static/media/hamburgerIcon.881ecedf.svg";